import {types} from 'mobx-state-tree';

const EquipmentModel = types
    .model('EquipmentModel', {
      name: types.string,
    });

export default EquipmentModel;
